export default __webpack_public_path__ + "static/media/ninjacustoms-logo_white.b9b5a4a3.png";